/**
 * @generated SignedSource<<2d3a70ec65b5c63e60563f5535351d25>>
 * @relayHash 890f87f75750a8a9dc513a5a1a510c2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 04a60de09cb156e78d1beccbc8a11e46210450dc67afe6d6f671a7d8e6330a09

import type { ConcreteRequest } from 'relay-runtime';
export type useSelectionCountContentMetadataQuery$variables = {
  contentIds: ReadonlyArray<string>;
};
export type useSelectionCountContentMetadataQuery$data = {
  readonly databaseContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly embedContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly folderContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly pageContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly slideContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly whiteboardContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly visibleDescendantsCount: AGG$Long;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useSelectionCountContentMetadataQuery = {
  response: useSelectionCountContentMetadataQuery$data;
  variables: useSelectionCountContentMetadataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentIds"
  }
],
v1 = {
  "kind": "Variable",
  "name": "ids",
  "variableName": "contentIds"
},
v2 = [
  {
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "visibleDescendantsCount"
      }
    ]
  }
],
v3 = [
  {
    "alias": "pageContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "page"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "whiteboardContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "whiteboard"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "databaseContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "database"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "embedContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "embed"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "folderContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "folder"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "slideContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "slide"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSelectionCountContentMetadataQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSelectionCountContentMetadataQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "890f87f75750a8a9dc513a5a1a510c2d",
    "id": "04a60de09cb156e78d1beccbc8a11e46210450dc67afe6d6f671a7d8e6330a09",
    "metadata": {},
    "name": "useSelectionCountContentMetadataQuery",
    "operationKind": "query",
    "text": "query useSelectionCountContentMetadataQuery($contentIds:[ID!]!){pageContent:content(ids:$contentIds,type:\"page\"){nodes{id,visibleDescendantsCount}},whiteboardContent:content(ids:$contentIds,type:\"whiteboard\"){nodes{id,visibleDescendantsCount}},databaseContent:content(ids:$contentIds,type:\"database\"){nodes{id,visibleDescendantsCount}},embedContent:content(ids:$contentIds,type:\"embed\"){nodes{id,visibleDescendantsCount}},folderContent:content(ids:$contentIds,type:\"folder\"){nodes{id,visibleDescendantsCount}},slideContent:content(ids:$contentIds,type:\"slide\"){nodes{id,visibleDescendantsCount}}}"
  }
};
})();

(node as any).hash = "df9fa24dda7ef9a6331f01e6b1156f83";

export default node;
